import React, { Component,useState,useEffect } from 'react';
import CountUp from 'react-countup';
import Datepicker from '../../common/datepicker';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from '../../../config.js'
import DynamicTable from '../../DynamicTable.js';

import DataTable from 'react-data-table-component';
import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';




const Permission = (props) => {


    const [formData, setFormData] = useState({
        permission_date: '',
        permission_hours: '',
        reason:"",
        });
        const [sample, setlist] = useState([]); 

        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(null);
        
        const [setform, setForm] = useState([]);
        const [sethour, setHour] = useState([]);
        const [setcount, setCount] = useState([]);

        const [table, setTable] = useState([]);

        const [isSaving, setIsSaving] = useState(false);
        const [searchTerm, setSearchTerm] = useState("");
        const [entriesPerPage, setEntriesPerPage] = useState(10);
        const [currentPage, setCurrentPage] = useState(1);


  const handleChange = (e) => {
  
    const { name, value } = e.target;
    setFormData({
    ...formData,
    [name]: value,
    });
    };

 
  
    useEffect(() => {
      
      axios
        .get(API_BASE_URL+'/permission', {
          headers: 
          { 
            Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
        }
        })
        .then((response) => {
          setTable(response.data.data.table);
          setCount(response.data.data.count[0].count);

        
          setLoading(false);
        })
        .catch((error) => {
        setError(error.message);
        setLoading(false);
        });
    }, []);

    useEffect(() => {
      
      axios
        .get(API_BASE_URL+'/permission_form', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
          }
        })
        .then((response) => {
          setForm(response.data.data.date);
          setHour(response.data.data.permission_hours);

          
          console.log("welceome");
          console.log(response.data.data.permission_hours);
          setLoading(false);
        })
        .catch((error) => {
        setError(error.message);
        setLoading(false);
        });
    }, []);
// Convert "01" or "HH:MM" to total minutes
const toMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = String(time).split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
};

const handleSubmit =  async (e) => {

    e.preventDefault(); // Prevent the default form submission

    if (isSaving) {
        return;
    }

    console.log('Form submitted:', formData);

    // Validate the selected hour against the remaining Available Permission
    const requested = toMinutes(formData.permission_hours);
    const available = toMinutes(setcount);

    if (requested <= 0) {
        toast.error("The permission hour field is required", {
            position: "bottom-right",
            autoClose: 5000,
            theme: "colored",
        });
        return;
    }

    if (requested > available) {
        toast.error(`You are available for ${setcount} only. Please select a shorter duration.`, {
            position: "bottom-right",
            autoClose: 5000,
            theme: "colored",
        });
        return;
    }

    setIsSaving(true);

    axios.post(API_BASE_URL+'/add_permission' ,formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

      'Content-Type': 'application/json', // Ensure JSON data is sent
    },
  }).then(response => {
       //  console.log(response.data);
            //  console.log(response.data.message);
            // })
            var status =response.data.status;
                if (status=='success')
                {
                    toast.success(response.data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        });
                        setTimeout(() => {
                          window.location.reload(); // Reload the page after delay
                        }, 3000);
                       
                }
               else if (status=='error')
                  {
                      toast.error(response.data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: "colored",
                          });
                          // setTimeout(() => {
                          //   window.location.reload(); // Reload the page after delay
                          // }, 3000);

                  }

                if (status != 'success') {
                    setIsSaving(false);
                }

            }).catch(error => {

                setIsSaving(false);

                // console.log(error);
                // console.log(error.response.data.message);
                toast.error(error?.response?.data?.message || "Failed to save the permission.", {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
             });
    
    
    
    
    };






const columns = [
  {
    name: 'Employee Name',
    selector: row => row['Employee Name'],
    sortable: true,
  },
  {
    name: 'Permission Date',
    selector: row => row['Permission Date'],
    sortable: true,
  },
  {
    name: 'Permission Hours',
    selector: row => row['Permission Hours'],
    sortable: true,
  },
  {
    name: 'Reason',
    selector: row => row['Reason'],
    wrap: true,
  },
  {
    name: 'Created Date',
    selector: row => row['Created Date'],
    sortable: true,
  },
  {
    name: 'Status',
    selector: row => row['Status'],
    sortable: true,
    cell: row => {
      if (row['Status'] === 'Approved')
        return <span className="badge badge-success">Approved</span>;
      if (row['Status'] === 'Rejected')
        return <span className="badge badge-danger">Rejected</span>;
      return <span className="badge badge-warning">Pending</span>;
    }
  }
];

/* ================= SEARCH + PAGINATION ================= */
useEffect(() => {
  setCurrentPage(1);
}, [searchTerm]);

const tableRows = Array.isArray(table) ? table : [];

const filteredRows = tableRows.filter(row =>
  Object.values(row)
    .join(' ')
    .toLowerCase()
    .includes(searchTerm.toLowerCase())
);

const totalPages = Math.ceil(filteredRows.length / entriesPerPage);
const paginatedRows = filteredRows.slice(
  (currentPage - 1) * entriesPerPage,
  currentPage * entriesPerPage
);


const { fixNavbar, statisticsOpen, statisticsClose } = props;

return (
<>
<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<ToastContainer/>

<div className="container-fluid">

 <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
  <a href="/permission" className="btn btn-primary btn-sm">
    Permission
  </a>
  {(["1", "6"].includes(localStorage.getItem("role_id"))) && (
    <a href="/permission-report" className="btn btn-outline-secondary btn-sm">
      Permission Report
    </a>
  )}
</div>




<div className="row clearfix">
<div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
<div className="card mb-2" style={{ borderLeft: "4px solid #1d3a8a" }}>
<div className="card-body w_sparkline d-flex justify-content-between align-items-center" style={{ padding: "10px 15px" }}>
<div className="details">
<span style={{ color: "#6c757d", fontWeight: 500, fontSize: "12px" }}>Available Permission</span>
<h4 className="mb-0" style={{ color: "#1d3a8a", fontWeight: 700 }}>
<span className="counter">{setcount}</span>
</h4>
</div>
<div className="w_chart">
<div id="mini-bar-chart1" className="mini-bar-chart" />
</div>
</div>
</div>

</div>
</div>

<form onSubmit={handleSubmit}>
<div className="row clearfix">
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-header d-flex justify-content-between align-items-center">
<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
<path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
<path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
<path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
</svg>
Apply Permission
</h3>
</div>
<div className="card-body">
<div className="row clearfix">
<div className="col-lg-4 col-md-12">
<label>Permission Date</label>
<div className="form-group">
<select  className="form-control custom-select required-input" id="permission_date"   name='permission_date'   value={formData.permission_date} onChange={handleChange}>
        <option value="" disabled>Select Date</option>
        {setform.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}



     {/* <option>2024-12-05</option>
     <option>2024-12-06</option>
     <option>2024-12-07</option>
     <option>2024-12-08</option> */}
      </select>
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-lg-4 col-md-12">
<label>Permission Hour</label>
<div className="form-group">
<select className="form-control custom-select required-input" id="permission_hours" name="permission_hours" value={formData.permission_hours} onChange={handleChange}>
        <option value="" disabled>Select Hour</option>
        {sethour.map(hour => (
          <option key={hour} value={hour}>
            {hour}
          </option>
        ))}
      </select>
</div>
</div>
<div className="col-lg-12 col-md-12">
<label>Reason</label>
<div className="form-group">
<textarea
rows={4}
type="text"
className="form-control required-input"
placeholder="Reason"
name="reason" value={formData.reason} onChange={handleChange}
/>
</div>
</div>
</div>
<button type="submit" className="btn btn-round btn-primary" disabled={isSaving}>
{isSaving ? "Saving..." : "Save"}
</button>

</div>

</div>


</div>
</div>

</form>

</div>
</div>
<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header d-flex justify-content-between align-items-center">
<h3 className="card-title mb-0">permission List</h3>

<div style={{ display: "flex", alignItems: "center" }}>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  <div style={{ position: "relative", width: "250px", marginLeft: "15px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value)}
    />
    {searchTerm && (
      <span
        onClick={() => setSearchTerm("")}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#999"
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>

</div>
<div className="card-body">
<div className="table-responsive">
<DataTable
  columns={columns}
  data={paginatedRows}
  striped
  highlightOnHover
  responsive
  persistTableHead
  noDataComponent="No permission records found"
/>

<Pagination
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={setCurrentPage}
/>
{/* <p>{data}</p> */}
</div>
</div>
</div>
</div>

</div>
</div>
</div>

</div>
</div>

</>
);
}


export default Permission;